import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "",
    keyword: "title1",
    type: "lineTitle",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名（ｶﾅ）",
    keyword: "bNameKana",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "bNameKanji",
    type: "text",
  },
  {
    title: "退職者名カナ（新）",
    keyword: "staffNameKana",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者名（新）",
    keyword: "staffNameKanji",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "退職年月日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "nRetireReasonCd",
    type: "text",
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "text",
  },
  {
    title: "退職者郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "退職者住所",
    keyword: "address",
    type: "text",
  },
  {
    title: "退職者電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title:
      "現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である",
    keyword: "continueTransferApplicable1Flg",
    type: "text",
  },
  {
    title:
      "現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である",
    keyword: "continueTransferApplicable2Flg",
    type: "text",
  },
  {
    title: "転職先の共済契約者番号",
    keyword: "aContractorNo",
    type: "text",
  },
  {
    title: "転職先の共済契約者名",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "ならない月",
    keyword: "notToBeMonth",
    type: "checkboxGroup",
    checkBoxList: [
      { label: "無", value: "none", disabled: true },
      { label: "4月", value: "apr", disabled: true },
      { label: "5月", value: "may", disabled: true },
      { label: "6月", value: "jun", disabled: true },
      { label: "7月", value: "jul", disabled: true },
      { label: "8月", value: "aug", disabled: true },
      { label: "9月", value: "sep", disabled: true },
      { label: "10月", value: "oct", disabled: true },
      { label: "11月", value: "nov", disabled: true },
      { label: "12月", value: "dec", disabled: true },
      { label: "1月", value: "jan", disabled: true },
      { label: "2月", value: "feb", disabled: true },
      { label: "3月", value: "mar", disabled: true },
    ],
  },
  {
    title: "退職月の出勤日数",
    keyword: "retireWorkingDayNum",
    type: "text",
  },
  {
    title: "賃金台帳",
    keyword: "wages",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "雇用契約書",
    keyword: "contractEmployment",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
];

const childcareLeaveTableHead = [
  {
    headTitle: "順番",
  },
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパ・ママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const headListWorkingDayNum = [
  {
    headTitle: "対象年月",
  },
  {
    headTitle: "出勤日数",
  },
];

const salaryTableHead: any = [
  {
    headTitle: "年月",
    align: "center",
  },
  {
    headTitle: "俸給表の額",
    align: "center",
  },
  {
    headTitle: "俸給の調整額",
    align: "center",
  },
];

const schema = {};

export {
  fakeTableList,
  schema,
  childcareLeaveTableHead,
  headListWorkingDayNum,
  salaryTableHead,
};
